angular.module('impactx.supplier').controller('SupplierDialogCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    '$sce',
    'panelService',
    'searchFilter',
    'ThemeWorldService',
    'TranslationService',
    '$context',
    'RFXCreateService',
    'SearchService',
    'ToolbarService',
    'AppConfiguration',
    'SearchFilterStorage',
    'SearchFilter',
    '$rootScope',
    '$location',
    'SearchExecution',
    'ProductViewService',
    '$redirect',
    '$mdDialog',
    'ixaProductComparison',
    SupplierDialogCtrl
]);

function SupplierDialogCtrl($scope, dataGen, $routeParams, $sce, panelService, searchFilter, ThemeWorldService,
                            TranslationService, $context, RFXCreateService, SearchService, ToolbarService, AppConfiguration,
                            SearchFilterStorage, SearchFilter, $rootScope, $location, SearchExecution, ProductViewService, $redirect, $mdDialog, ixaProductComparison) {
    var supplierCtrl = this;
    supplierCtrl.supplierId = $routeParams.id;
    supplierCtrl.getSupplierPanelColor = panelService.getSupplierPanelColor;
    var scrollPositionList = 0;
    this.translationService = TranslationService;
    this.panelsInitialized = false;
    this.showScrollTopButton = false;
    this.pageNumber = 1;
    this.expandCatalogSupplierDefault = SearchService.userSearchConfig('expandCatalogSupplierDefault');
    this.expandTenderLotDefault = SearchService.userSearchConfig('expandTenderLotDefault');
    this.tenderAvailable = AppConfiguration.get('tenderAvailable');
    this.lotAvailable = AppConfiguration.get('lotAvailable');
    this.displayAllResultsAsList = AppConfiguration.get('displayAllResultsAsList');
    this.informationIsOpen = SearchService.userSearchConfig('informationIsOpen');
    this.showPanelLabel = AppConfiguration.get('showPanelLabels');
    ToolbarService.showSearchFilterToggle();
    this.filterNeedsReset = {value: false};
    this.SearchFilter = SearchFilter;
    supplierCtrl.searchWithReset = function (item) {
        supplierCtrl.filterNeedsReset.value = true;
        SearchFilter.setSearchInputClassification(null);
        var freshFilter = SearchFilterStorage.getFreshFilter();
        if (freshFilter) {
            supplierCtrl.filter = freshFilter;
            supplierCtrl.filter.supplierId = {value: $routeParams.id};
            supplierCtrl.filter.dialogFilter = "supplier";
            SearchFilterStorage.setSupplierFilter($routeParams.id, supplierCtrl.filter);
            supplierCtrl.filter.searchInput.value = searchFilter.searchInput;
            if (item) {
                if (item.isClassification) {
                    supplierCtrl.filter.guidingClassification.selected = {id: item.id, value: item.value};
                }
            }
            SearchFilter.setFilters(supplierCtrl.filter);
        }
        supplierCtrl.searchAll();
    }

    var currentLocation = $location.path();
    var backButtonUsed = $rootScope.location !== currentLocation;
    var storedSearchFilterObject = SearchFilterStorage.getSupplierFilter($routeParams.id);
    if (storedSearchFilterObject && ($routeParams.useSetFilter || storedSearchFilterObject.searchInputUsed || backButtonUsed)) {
        storedSearchFilterObject.searchInputUsed = false;
        supplierCtrl.filter = storedSearchFilterObject;
        searchFilter.searchInput = supplierCtrl.filter.searchInput.value;
        var guidingClassification = supplierCtrl.filter.guidingClassification;
        if (guidingClassification && guidingClassification.superEntries) {
            var superEntry = guidingClassification.superEntries[guidingClassification.superEntries.length - 1];
            SearchFilter.setSearchInputClassification(superEntry);
        }
        else {
            SearchFilter.setSearchInputClassification(null);
        }
        if(!supplierCtrl.filter.productsPerPage)
        {
            supplierCtrl.filter.productsPerPage = SearchService.getNumberOfProductRows();
        }
        SearchFilter.setFilters(supplierCtrl.filter);
        getDialogData(backButtonUsed);
    }
    else {
        SearchFilter.setSearchInputClassification(null);
        var freshFilter = SearchFilterStorage.getFreshFilter();
        if (freshFilter) {
            supplierCtrl.filter = freshFilter;
            supplierCtrl.filter.supplierId = {value: $routeParams.id};
            supplierCtrl.filter.dialogFilter = "supplier";
            SearchFilterStorage.setSupplierFilter($routeParams.id, supplierCtrl.filter);
            searchFilter.searchInput = supplierCtrl.filter.searchInput.value;
            SearchFilter.setFilters(supplierCtrl.filter);
            getDialogData();
        }
        else {
            var result = {};
            dataGen.getData(result, {}, "/search/filter", null, true).then(function () {
                SearchFilterStorage.setFreshFilter(result.data);
                supplierCtrl.filter = result.data;
                supplierCtrl.filter.supplierId = {value: $routeParams.id};
                supplierCtrl.filter.dialogFilter = "supplier";
                SearchFilterStorage.setSupplierFilter($routeParams.id, supplierCtrl.filter);
                if ($location.path() === currentLocation) {
                    //only if we are still on the vCatalog page.
                    searchFilter.searchInput = supplierCtrl.filter.searchInput.value;
                    SearchFilter.setFilters(supplierCtrl.filter);
                    getDialogData()
                }
            });
        }
    }

    function getDialogData(backButtonUsed) {
        return dataGen.getData($scope, {id: $routeParams.id}, "/supplier/view").then(function () {
            supplierCtrl.searchAll(true).then(function () {
                supplierCtrl.panelsInitialized = true;
                if(backButtonUsed) {
                    SearchFilterStorage.scrollToSearchScrollPosition("supplier", '#search-view');
                }
            });
            $scope.themeWorldActive = $scope.data.themeWorldActive;
            $scope.no_result = $scope.themeWorldActive && $scope.noSearchResults;
            $scope.description = $sce.trustAsHtml($scope.data.description);
            $scope.trns.showAll = TranslationService.get("showAll");

            defineButtons();
        });
    }

    supplierCtrl.addToThemeWorld = function ($event) {
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.addSuppliersToThemeWorld([$scope.data]);
    };

    supplierCtrl.removeFromThemeWorld = function ($event) {
        var supplierIds = [];
        $scope.data.canAddToThemeWorld = true;
        $scope.data.canRemoveFromThemeWorld = false;
        supplierIds.push($scope.id);
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.removeSuppliersFromThemeWorld($context.hasActiveThemeWorld.id, supplierIds);
    };

    supplierCtrl.addToProductView = function ($event) {
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.addSuppliersToProductView([$scope.data]);
    };

    supplierCtrl.removeFromProductView = function ($event) {
        var supplierIds = [];
        $scope.data.canAddToProductView = true;
        $scope.data.canRemoveFromProductView = false;
        supplierIds.push($scope.id);
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.removeSuppliersFromProductView($context.hasActiveProductView.id, supplierIds);
    };

    supplierCtrl.canAddToThemeWorld = function () {
        return $scope.data.canAddToThemeWorld
    };

    supplierCtrl.canRemoveFromThemeWorld = function () {
        return $scope.data.canRemoveFromThemeWorld
    };

    supplierCtrl.canAddToProductView = function () {
        return $scope.data.canAddToProductView
    };

    supplierCtrl.canRemoveFromProductView = function () {
        return $scope.data.canRemoveFromProductView
    };

    supplierCtrl.canShowFreeformOfferDialog = function () {
        return AppConfiguration.get('useFFOfferDialog') && $scope.data && $scope.data.isFreeFormAllowed;
    };

    supplierCtrl.createScrollList = function () {
        $scope.scrollList = [];

        if (supplierCtrl.tenders) {
            var numberOfTenders = supplierCtrl.numberOfTenders;
            if (numberOfTenders > 1) {
                $scope.scrollList.push({
                    id: "tendersAndLots",
                    label: numberOfTenders + " " + $scope.trns.tenders,
                    func: openTenderArea
                })
            }
            if (numberOfTenders == 1) {
                $scope.scrollList.push({
                    id: "tendersAndLots",
                    label: numberOfTenders + " " + $scope.trns.tender,
                    func: openTenderArea
                })
            }
        }

        if (supplierCtrl.lots) {
            var numberOfLots = supplierCtrl.numberOfLots;
            if (numberOfLots > 1) {
                $scope.scrollList.push({
                    id: "tendersAndLots",
                    label: numberOfLots + " " + $scope.trns.lots,
                    func: openLotArea
                })
            }
            if (numberOfLots == 1) {
                $scope.scrollList.push({
                    id: "tendersAndLots",
                    label: numberOfLots + " " + $scope.trns.lot,
                    func: openLotArea
                })
            }
        }

        if (supplierCtrl.catalogs) {
            var numberOfVCats = supplierCtrl.numberOfCatalogs;
            if (numberOfVCats > 1) {
                $scope.scrollList.push({
                    id: "catalog",
                    label: numberOfVCats + " " + $scope.trns.vcats,
                    func: openCatalogArea
                })
            }
            if (numberOfVCats == 1) {
                $scope.scrollList.push({
                    id: "catalog",
                    label: numberOfVCats + " " + $scope.trns.vcat,
                    func: openCatalogArea
                })
            }
        }
        var numberOfPros = supplierCtrl.numberOfProducts;
        if (numberOfPros > 1) {
            $scope.scrollList.push({id: "pro", label: numberOfPros + " " + $scope.trns.products})
        }
        if (numberOfPros == 1) {
            $scope.scrollList.push({id: "pro", label: numberOfPros + " " + $scope.trns.product})
        }
        if ($scope.scrollList.length > 0) {
            $scope.scrollList.unshift({id: "header", label: $scope.trns.headerData, func: openHeaderArea});
        }
        ToolbarService.setScrollMenu($scope.scrollList);
    };

    supplierCtrl.showName1 = function () {
        return !angular.equals($scope.data.name, $scope.data.address.name1.value);
    };

    supplierCtrl.createRFX = function () {
        RFXCreateService.createRFX("supplier", $routeParams.id, $routeParams.id);
    };


    supplierCtrl.showScrollTop = function (showScrollTop, scrollPosition) {
        supplierCtrl.showScrollTopButton = showScrollTop;
        scrollPositionList = scrollPosition;
    };

    supplierCtrl.searchProducts = function (index, selectedSort) {
        supplierCtrl.filter.productPageNumber = index;
        supplierCtrl.filter.productsPerPage = SearchService.getNumberOfProductRows();

        if (selectedSort) {
            supplierCtrl.filter.sort.selected = selectedSort;
        }
        return SearchService.searchProducts(supplierCtrl.filter.productPageNumber).then(function (searchResults) {
            if (searchResults) {
                angular.extend(supplierCtrl, searchResults);
            }
        })
    };

    supplierCtrl.searchAll = function (onInit) {
        if (!onInit && supplierCtrl.filter) {
            supplierCtrl.filter.productPageNumber = 1;
        }
        return SearchService.searchAll().then(function (searchResult) {
            angular.extend(supplierCtrl, searchResult);
            supplierCtrl.createScrollList();
            $scope.noSearchResults = searchResult.catalogs.length === 0 && searchResult.lots.length === 0
                && searchResult.tenders.length === 0 && searchResult.products.length === 0;
            $scope.no_result = $scope.themeWorldActive && $scope.noSearchResults;
        });
    };

    supplierCtrl.scrollToTop = function () {
        angular.element('#search-view').animate({
            scrollTop: scrollPositionList
        }, 200);
    };

    supplierCtrl.toggleInformation = function () {
        supplierCtrl.informationIsOpen = !supplierCtrl.informationIsOpen
    };

    supplierCtrl.showBasketItemOfferDialog = function (ev) {
        $mdDialog.show({
            controller: "EditFreeFormOfferCtrl",
            controllerAs: "editFreeFormOfferCtrl",
            templateUrl: 'modules/basket/templates/freeformofferdialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                basketItemGroupId: 0,
                headerId: 0,
                hideOrderData: false,
                lotId: 0,
                supplierId: $routeParams.id,
                product: null,
                allowBANF: true,
                onlyBANF: false
            }
        })
            .then(function () {
                if (answer && answer.freeformContract) {
                    supplierCtrl.showBasketItemDialog(ev, answer.freeformContract.id);
                }
                else {
                    $context.refreshBasket({}, dataGen, $context);
                }
            }, function () {
            });
    };

    supplierCtrl.showBasketItemDialog = function (ev, banfContractId) {
        var basketItemId = 0;

        var entryPointGet = banfContractId && banfContractId > 0 ?"/basket/item/freeform/view/banf" : "/basket/item/freeform/view";
        var entryPointSave = "/basket/item/freeform/save";
        var controller = "EditFreeFormCtrl";

        $mdDialog.show({
            controller: controller,
            templateUrl: 'shared/requestitem/templates/requestitemdialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                itemId: basketItemId,
                headerId: 0,
                entryPointGet: entryPointGet,
                entryPointSave: entryPointSave,
                changeAATEntryPoint: '/basket/item/updateavailablecontrols',
                lotId: 0,
                productId: -1,
                readOnly: false,
                materialGroupMappingEntryPoint: "/basket/input/eclassmapping",
                hideOrderData: false,
                headerTable: "BKH",
                contractId: banfContractId
            }
        })
            .then(function () {
                $context.refreshBasket({}, dataGen, $context);
            }, function () {
            });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.createRFX,
                action: supplierCtrl.createRFX,
                type: 'dialogaction',
                condition: supplierCtrl.canCreateRFX
            },
            {
                label: $scope.trns.addFreeFormOffer,
                action: supplierCtrl.showBasketItemOfferDialog,
                type: 'dialogaction',
                condition: supplierCtrl.canShowFreeformOfferDialog
            },
            {
                label: TranslationService.get('addToThemeWorld'),
                action: supplierCtrl.addToThemeWorld,
                condition: supplierCtrl.canAddToThemeWorld,
                process: 'EditThemeWorld'
            },
            {
                label: TranslationService.get('removeFromThemeWorld'),
                action: supplierCtrl.removeFromThemeWorld,
                condition: supplierCtrl.canRemoveFromThemeWorld,
                process: 'EditThemeWorld'
            },
            {
                label: TranslationService.get('addToProductView'),
                action: supplierCtrl.addToProductView,
                condition: supplierCtrl.canAddToProductView,
                process: 'EditProductView'
            },
            {
                label: TranslationService.get('removeFromProductView'),
                action: supplierCtrl.removeFromProductView,
                condition: supplierCtrl.canRemoveFromProductView,
                process: 'EditProductView'
            },
            {
                labelFunction: function (){return ixaProductComparison.getRedirectButtonLabel()},
                linkFunction: function ()
                {
                    return "productcomparison"
                },
                type: 'link',
                condition: function ()
                {
                    return ixaProductComparison.getProductComparisonCount() > 1
                }
            },
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    this.canCreateRFX = function () {
        return $scope.data.showRFXButton;
    }

    $scope.$on('$routeChangeStart', function (event, newRoute, oldRoute) {
        var detailList = newRoute.originalPath.indexOf("/search.") > - 1;
        if (!detailList && newRoute.originalPath !== "/search") {
            SearchFilter.setSearchInputClassification(null);
            searchFilter.searchInput = "";
            SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());
        }
        if (newRoute.$$route.originalPath !== oldRoute.$$route.originalPath) {
            SearchFilterStorage.setSearchFilterPlaceHolder(null);
            SearchFilterStorage.setSearchScrollPosition("supplier", document.getElementById('search-view').scrollTop);
        }
    });

    $scope.$on('MainSearchTriggered', function () {
        supplierCtrl.informationIsOpen = false;
    });

    function openTenderArea() {
        supplierCtrl.expandTenderLotDefault = true;
        supplierCtrl.tenderPaneSelected = true;
        supplierCtrl.lotPaneSelected = false;
    }

    function openLotArea() {
        supplierCtrl.expandTenderLotDefault = true;
        supplierCtrl.tenderPaneSelected = false;
        supplierCtrl.lotPaneSelected = true;
    }

    function openCatalogArea() {
        supplierCtrl.expandCatalogSupplierDefault = true;
        supplierCtrl.catalogPaneSelected = true;
    }

    function openHeaderArea() {
        supplierCtrl.informationIsOpen = true;
    }

    $scope.$on('$destroy', function () {
        SearchService.setUserSearchConfigParameter('expandCatalogSupplierDefault', supplierCtrl.expandCatalogSupplierDefault);
        SearchService.setUserSearchConfigParameter('expandTenderLotDefault', supplierCtrl.expandTenderLotDefault);
        SearchService.setUserSearchConfigParameter('informationIsOpen', supplierCtrl.informationIsOpen);
        ToolbarService.hideSearchFilterToggle();
    });

    supplierCtrl.anyResults = function () {
        return (supplierCtrl.lotAvailable && supplierCtrl.lots && supplierCtrl.lots.length > 0) ||
            (supplierCtrl.tenderAvailable && supplierCtrl.tenders && supplierCtrl.tenders.length > 0) ||
            (supplierCtrl.catalogs && supplierCtrl.catalogs.length > 0) ||
            (supplierCtrl.products && supplierCtrl.products.length > 0);
    };

    supplierCtrl.showNoResultsHint = function () {
        return !$context.hasActiveThemeWorldSearch || !$context.hasActiveThemeWorldSearch.value;
    }

    supplierCtrl.updateTenders = function (pageNumber, pageSize) {
        SearchFilter.setSupplierId(supplierCtrl.supplierId);
        return SearchExecution.searchTenders(SearchFilter.getFilters(), pageSize, pageNumber).then(function (result) {
            var numberOfResults = 0;
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                supplierCtrl.tenders = supplierCtrl.tenders.concat(searchResults.tenders);
                numberOfResults = searchResults.tenders.length;
            }
            return numberOfResults;
        })
    };

    supplierCtrl.updateLots = function (pageNumber, pageSize) {
        SearchFilter.setSupplierId(supplierCtrl.supplierId);
        return SearchExecution.searchLots(SearchFilter.getFilters(), pageSize, pageNumber).then(function (result) {
            var numberOfResults = 0;
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                supplierCtrl.lots = supplierCtrl.lots.concat(searchResults.lots);
                numberOfResults = searchResults.lots.length;
            }
            return numberOfResults;
        })
    };

    supplierCtrl.updateCatalogs = function (pageNumber, pageSize) {
        SearchFilter.setSupplierId(supplierCtrl.supplierId);
        return SearchExecution.searchCatalogs(SearchFilter.getFilters(), pageSize, pageNumber).then(function (result) {
            var numberOfResults = 0;
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                supplierCtrl.catalogs = supplierCtrl.catalogs.concat(searchResults.catalogs);
                numberOfResults = searchResults.catalogs.length;
            }
            return numberOfResults;
        })
    };

    supplierCtrl.redirectToContacts = function () {
        $redirect.redirectTo(null, "search.contact/supplier/" + supplierCtrl.supplierId);
    }

    this.searchTerm = function (term) {
        SearchFilter.setFilterIdentifier();
        searchFilter.searchInput = term;

        SearchFilter.setFilters(SearchFilterStorage.getFreshFilter())

        SearchFilter.getFilters().supplierId = {value: $routeParams.id};
        SearchFilter.getFilters().dialogFilter = "supplier";
        SearchFilterStorage.setSupplierFilter($routeParams.id, SearchFilter.getFilters());

        searchFilter.resetDetailFilter().then(function () {
            var filterData = {};
            if ($context.hasActiveShopView.value) {
                searchFilter.listSearch.value = true;
            }
            SearchFilter.getFilters().searchInput.value = searchFilter.searchInput;
            SearchFilter.getFilters().searchInputUsed = true;
            supplierCtrl.searchWithReset();
        });
    };
}